import { Login } from "../pages/Login/Login";
import { Home } from "../pages/Home/Home";
import { NotFound } from "../pages/NotFound/NotFound";

export const routes = [
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/home",
    component: Home,
    isProtected: true,
  },
  {
    path: "*", // Catch-all route for 404
    component: NotFound,
  },
];
